import { Injectable } from '@angular/core';

import { setInitialStoreState } from '../../../../../common';
import { HandlingUnitOverviewFacade } from './handling-unit-overview.facade';
import { HandlingUnitMaterialsFacade } from './handling-unit-materials/handling-unit-materials.facade';

@Injectable({
  providedIn: 'root',
})
export class HandlingUnitOverviewGuard  {
  constructor(
    private handlingUnitOverviewFacade: HandlingUnitOverviewFacade,
    private handlingUnitMaterialsFacade: HandlingUnitMaterialsFacade,
  ) {}

  canDeactivate(): boolean {
    return setInitialStoreState(this.handlingUnitMaterialsFacade);
  }
}
